export const SYSTEM_TITLE = '小売向け機器DR管理システム'

// ---------------------------------------------
// 認可[se-user-pool] [nodejs:14]
// ---------------------------------------------
// 本番環境設定
// const awsConfig = {
//   Auth: {
//     region: "ap-northeast-1",
//     userPoolId: "ap-northeast-1_iKpGxRjjD",
//     userPoolWebClientId: "6d09mosad4c7s57dnflstg2bpe"
//   },
//   API: {
//     endpoints : [
//       {
//         name: "vpp_flex_retail",
//         endpoint: "https://9363rg6b36.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail"
//       }
//     ]
//   },
//   RegisterEndpoint: "https://9363rg6b36.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail",
//   SystemTitle: SYSTEM_TITLE,
// }


// ステージ環境設定
// const awsConfig = {
//   Auth: {
//     region: 'ap-northeast-1',
//     userPoolId: 'ap-northeast-1_FcDXZd8lc',
//     userPoolWebClientId: '6titukk2ilj4mbrlecefohpv9e',
//   },
//   API: {
//     endpoints : [
//       {
//         name: 'vpp_flex_retail',
//         endpoint: 'https://i6te7x5u10.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
//       }
//     ]
//   },
//   RegisterEndpoint: 'https://i6te7x5u10.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
//   SystemTitle: SYSTEM_TITLE + ' (STG環境)',
// }


// ------------------------------------------------------------------------------------------
// 認可[AWS_IAM]（SE_VPP2022-5091）+ 二要素認証（SE_VPP2022-4984）[nodejs:18]
// ------------------------------------------------------------------------------------------
// 本番環境設定
const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: "ap-northeast-1_iKpGxRjjD",
      userPoolClientId: "6i2n5nei0t4vbldl91k72l122k",
      identityPoolId: 'ap-northeast-1:a73ccc47-396b-4631-a82e-9579adf3437a',
    },
    loginWith: {
      username: true,
      email: true,
      phone: false,
    },
  },
  API: {
    REST: {
      vpp_flex_retail: {
        endpoint: 'https://h5gnjx0dgc.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
        region: "ap-northeast-1",
      },
    },
  },
  RegisterEndpoint: 'https://h5gnjx0dgc.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
  SystemTitle: SYSTEM_TITLE,
};


// ステージ環境設定
// const awsConfig = {
//   Auth: {
//     Cognito: {
//       userPoolId: "ap-northeast-1_FcDXZd8lc",
//       userPoolClientId: "7nbtjpu4anro255ibred1uiqil",
//       identityPoolId: 'ap-northeast-1:8a8a027f-94de-451e-b633-585f4c109476',
//     },
//     loginWith: {
//       username: true,
//       email: true,
//       phone: false,
//     },
//   },
//   API: {
//     REST: {
//       vpp_flex_retail: {
//         endpoint: 'https://tnmevkagwa.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
//         region: "ap-northeast-1",
//       },
//     },
//   },
//   RegisterEndpoint: 'https://tnmevkagwa.execute-api.ap-northeast-1.amazonaws.com/v1/vpp-flex-retail',
//   SystemTitle: SYSTEM_TITLE + ' (STG環境)',
// };

export default awsConfig;